import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
// import { API_URL } from "../../config/config";

const API_URL = process.env.REACT_APP_API_URL;

// Helper to get token from Redux store or session/local storage
const getAuthToken = (getState) =>
  (getState && getState().auth && getState().auth.token) ||
  sessionStorage.getItem("access_token") ||
  localStorage.getItem("access_token");

export const fetchLatestSteps = createAsyncThunk(
  "steps/fetchLatest",
  async (patientId, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const response = await axios.get(
        `${API_URL}/vitals/patient/${patientId}/steps/latest`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue("Failed to fetch steps data");
    }
  }
);

const stepsSlice = createSlice({
  name: "steps",
  initialState: { data: null, loading: false, error: null },
  reducers: {
    clearSteps(state) {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLatestSteps.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLatestSteps.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchLatestSteps.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const { clearSteps } = stepsSlice.actions;

export const selectSteps = (state) => state.steps;

export default stepsSlice.reducer;



// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
// // import { API_URL } from "../../config/config";

// const API_URL = process.env.REACT_APP_API_URL;

// export const fetchLatestSteps = createAsyncThunk(
//   "steps/fetchLatest",
//   async (patientId, thunkAPI) => {
//     try {
//       const response = await axios.get(
//         `${API_URL}/vitals/patient/${patientId}/steps/latest`
//       );
//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue("Failed to fetch steps data");
//     }
//   }
// );

// const stepsSlice = createSlice({
//   name: "steps",
//   initialState: { data: null, loading: false, error: null },
//   reducers: {
//     clearSteps(state) {
//       state.data = null;
//       state.loading = false;
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchLatestSteps.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchLatestSteps.fulfilled, (state, action) => {
//         state.data = action.payload;
//         state.loading = false;
//       })
//       .addCase(fetchLatestSteps.rejected, (state, action) => {
//         state.error = action.payload;
//         state.loading = false;
//       });
//   },
// });

// export const { clearSteps } = stepsSlice.actions;

// export const selectSteps = (state) => state.steps;

// export default stepsSlice.reducer;
